import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { LoginDir } from './login.component';
import { UpgradeModule } from '@angular/upgrade/static';

@NgModule({
  imports: [
    CommonModule,
    UpgradeModule
  ],
  declarations: [
    //LoginDir
  ],
  exports: [
    //LoginDir
  ]
})
export class AppV1Module { 
  constructor() {
    
  }
}


